module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gygAA"))).then(() => parcelRequire('hEqeo'));